import React from 'react'
import Navbar from '../Navbar/Navbar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import "./home.css"
import { Link } from 'react-router-dom'
import Courses from '../Courses/Courses'
import ContactUs from '../ContactUs/ContactUs'
import Instructors from '../Instructors/Instructors'
import Footer from '../Footer/Footer'

import HeroImage from "./Home.png";
import StatsImage from "./Stats.png";
import TestimonialsImage from "./Testimonials.png";


export default function Home() {
  return (
    <>
    <Navbar variant='light' />

    <header className='homeHero'>
      <div className='homeHero__bg' aria-hidden="true" />
      <div className='container homeHero__container'>
        <div className='row align-items-center g-4'>
          <div className='col-12 col-lg-6'>
            <div className='homeHero__badge'>PMA Academy</div>
            <h1 className='homeHero__title'>A smarter way to prepare for the PMP exam and others.</h1>
            <p className='homeHero__subtitle'>Learn with structured courses, great instructors, and practical practice—built for focus and momentum.</p>

            <div className='homeHero__actions'>
              <Link to='/Courses' className='btn btn-primary homeHero__primaryBtn'>
                Explore Courses <FontAwesomeIcon icon={faArrowRight} className='ms-2' />
              </Link>
              <Link to='/AboutUs' className='btn btn-outline-dark homeHero__secondaryBtn'>
                Why PMA Academy
              </Link>
            </div>

            <div className='homeHero__highlights'>
              <div className='homeHero__highlight'>
                <div className='homeHero__highlightTitle'>Modern content</div>
                <div className='homeHero__highlightText'>Clear structure that keeps you progressing.</div>
              </div>
              <div className='homeHero__highlight'>
                <div className='homeHero__highlightTitle'>Practical approach</div>
                <div className='homeHero__highlightText'>Designed around real exam thinking.</div>
              </div>
              <div className='homeHero__highlight'>
                <div className='homeHero__highlightTitle'>All-in-one</div>
                <div className='homeHero__highlightText'>Courses, instructors, and support in one place.</div>
              </div>
            </div>
          </div>

          <div className='col-12 col-lg-6'>
            <div className='homeHero__media'>
              <div className='homeHero__mediaFrame'>
                {/* <img className='homeHero__mediaImg' src={HeroImage} alt='PMP Academy' loading='eager' /> */}
              </div>

              <div className='homeHero__floatingCard homeHero__floatingCard--stats'>
                <img src={StatsImage} alt='Stats' className='homeHero__floatingImg' loading='lazy' />
              </div>
              <div className='homeHero__floatingCard homeHero__floatingCard--testimonials'>
                <img src={TestimonialsImage} alt='Testimonials' className='homeHero__floatingImg' loading='lazy' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <section className='homeSection homeSection--features'>
      <div className='container'>
        <div className='row align-items-stretch g-3'>
          <div className='col-12 col-lg-4'>
            <div className='homeCard'>
              <div className='homeCard__title'>Study smarter</div>
              <div className='homeCard__text'>A clear learning path that keeps you consistent, without overwhelm.</div>
              <Link to='/Courses' className='homeCard__link'>Browse courses <FontAwesomeIcon icon={faArrowRight} className='ms-2' /></Link>
            </div>
          </div>
          <div className='col-12 col-lg-4'>
            <div className='homeCard'>
              <div className='homeCard__title'>Expert instructors</div>
              <div className='homeCard__text'>Learn from instructors who explain concepts clearly and practically.</div>
              <Link to='/Instructors' className='homeCard__link'>Meet instructors <FontAwesomeIcon icon={faArrowRight} className='ms-2' /></Link>
            </div>
          </div>
          <div className='col-12 col-lg-4'>
            <div className='homeCard homeCard--accent'>
              <div className='homeCard__title'>Ready to start?</div>
              <div className='homeCard__text'>Pick a course and begin your preparation today.</div>
              <Link to='/login' className='btn btn-primary homeCard__cta'>Start now</Link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className='homeSection homeSection--cta'>
      <div className='container'>
        <div className='homeCta'>
          <div>
            <h2 className='homeCta__title'>Everything you need, in one place.</h2>
            <p className='homeCta__text'>Courses, instructors, and support—designed to keep you moving forward.</p>
          </div>
          <div className='homeCta__actions'>
            <Link to='/Courses' className='btn btn-primary homeCta__btn'>Explore Courses</Link>
            <Link to='/ContactUs' className='btn btn-outline-dark homeCta__btn'>Contact Us</Link>
          </div>
        </div>
      </div>
    </section>

<Courses/>

    <Instructors/>
    <ContactUs/>


    <Footer/>

    </>

  )}
